export default __webpack_public_path__ + "assets/Chase-47d80b3e18f41f4ae32150a43c27f892.svg";